import { render, staticRenderFns } from "./calibrationLabOrders.vue?vue&type=template&id=85de6afa&scoped=true&"
import script from "./calibrationLabOrders.vue?vue&type=script&lang=js&"
export * from "./calibrationLabOrders.vue?vue&type=script&lang=js&"
import style0 from "./calibrationLabOrders.vue?vue&type=style&index=0&id=85de6afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85de6afa",
  null
  
)

export default component.exports